import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React from "react";
import styles from "./styles";
const firebase = require("firebase");
require("firebase/firestore");

class Roles extends React.Component {
  constructor() {
    super();
    this.state = {
      nombre: "",
      state: null,
      open: false,
      setOpen: true,
      openNu: false,
      sele: {
        id: null,
        checkedA: null,
        checkedB: null,
        checkedC: null,
        checkedD: null,
        checkedE: null,
        checkedF: null,
        checkedG: null,
        checkedH: null,
        checkedI: null,
        checkedJ: null
      }
    };
  }
  //const [open, setOpen] = React.useState(false);
  /* const [state, setState] = React.useState({
    checkedA: true,
    checkedB: true,
    checkedC: true,
    checkedD: true,
    checkedF: true,
    checkedG: true,
    checkedH: true,
    checkedI: true,
    checkedJ: true
  });*/
  componentDidMount = () => {
    firebase
      .firestore()
      .collection("rol")
      .orderBy("id", "asc")
      .onSnapshot(serverUpdate => {
        const deCanela = serverUpdate.docs.map(_doc => {
          const data = _doc.data();
          data["id"] = _doc.id;
          return data;
        });

        this.setState({ deCanela });
      });
  };
  fillDb = () => {
    console.log("ugly sueter");
    if (!this.state.pruebas) {
      firebase
        .firestore()
        .collection("rol")
        .doc(this.state.nombre)
        .set({
          id: this.state.nombre,
          checkedA: true,
          checkedB: true,
          checkedC: false,
          checkedD: false,
          checkedE: false,
          checkedF: false,
          checkedG: false,
          checkedH: true,
          checkedI: false,
          checkedJ: false
        })
        .then(function(loko) {
          console.log("Document successfully written!", loko);
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
        });
    } else {
      firebase
        .firestore()
        .collection("rol")
        .doc(this.state.nombre)
        .set({
          id: this.state.nombre,
          checkedA: true,
          checkedB: true,
          checkedC: false,
          checkedD: false,
          checkedE: false,
          checkedF: false,
          checkedG: false,
          checkedH: true,
          checkedI: false,
          checkedJ: false
        })
        .then(function() {
          console.log("Document successfully written!");
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
        });
    }
  };

  editNote = async note => {
    console.log("webos", note);
  };

  handleChange = async (e, c, n) => {
    //  e: es el objeto
    //  c: es el valor boolean
    //  n: es el nombre de la propiedad objeto sintetico
    //  console.log("handleChange", e.id, "original ",!c , "queremos ", c);
    const bol = {};

    bol[`${n}`] = c;

    console.log("este el el bol a ver que tranza", bol);
    await firebase
      .firestore()
      .collection("rol")
      .doc(e.id)
      .update(bol)
      .then(function() {
        console.log("se escribio permiso");
      })
      .catch(function(error) {
        console.error("Error escribiendo permiso: ", error);
      });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClickOpenNu = () => {
    this.setState({ openNu: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    const datos = this.state.deCanela;
    return (
      <div>
        <List>
          <ListItem>
            <div className={classes.textSection}>
              <h4
                className={classes.itemText}
                style={{ width: "33%", color: "#1506A5" }}
              >
                Roles
              </h4>
              <h4
                className={classes.itemText}
                style={{ width: "33%", color: "#1506A5" }}
              >
                Permisos
              </h4>
            </div>
          </ListItem>
          <Divider />
        </List>
        {datos ? (
          <List>
            {datos.map((item, _index) => {
              return (
                /*
                   {datos ? (
          <List>
            {datos.map((item, _index) => {
              return (

              ) )} </List> )}
                */
                <ListItem button key={item.id}>
                  <h4
                    className={classes.itemText}
                    style={{
                      width: "40%",
                      fontWeight: "100",
                      textTransform: "capitalize"
                    }}
                  >
                    {item.id}
                  </h4>
                  <h4 className={classes.itemText2} style={{ width: "33%" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          fontSize="5px"
                          checked={item.checkedA ? true : false}
                          onClick={e =>
                            this.handleChange(
                              item,
                              !item.checkedA,
                              e.target.value
                            )
                          }
                          value="checkedA"
                          color="primary"
                        />
                      }
                      // labelStyle={{ fontSize: 3 }}
                      label="Lectura"
                    />
                  </h4>
                  <h4
                    className={classes.itemText2}
                    style={{ width: "33%", float: "center" }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={item.checkedB ? true : false}
                          // onChange={this.handleChange("checkedB")}
                          onClick={e =>
                            this.handleChange(
                              item,
                              !item.checkedB,
                              e.target.value
                            )
                          }
                          value="checkedB"
                          color="primary"
                        />
                      }
                      label="Agregar"
                    />
                  </h4>
                  <h4 className={classes.itemText2} style={{ width: "33%" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={item.checkedC ? true : false}
                          //  onChange={this.handleChange("checkedC")}
                          onClick={e =>
                            this.handleChange(
                              item,
                              !item.checkedC,
                              e.target.value
                            )
                          }
                          value="checkedC"
                          color="primary"
                        />
                      }
                      label="Editar"
                    />
                  </h4>
                  <h4 className={classes.itemText} style={{ width: "33%" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={item.checkedD ? true : false}
                          // onChange={this.handleChange("checkedB")}
                          onClick={e =>
                            this.handleChange(
                              item,
                              !item.checkedD,
                              e.target.value
                            )
                          }
                          value="checkedD"
                          color="primary"
                        />
                      }
                      label="Eliminar"
                    />
                  </h4>
                  <h4 className={classes.itemText} style={{ width: "33%" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={item.checkedE ? true : false}
                          // onChange={this.handleChange("checkedE")}
                          onClick={e =>
                            this.handleChange(
                              item,
                              !item.checkedE,
                              e.target.value
                            )
                          }
                          value="checkedE"
                          color="primary"
                        />
                      }
                      label="Asignar"
                    />
                  </h4>
                  <h4 className={classes.itemText} style={{ width: "33%" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={item.checkedF ? true : false}
                          //  onChange={this.handleChange("checkedB")}
                          onClick={e =>
                            this.handleChange(
                              item,
                              !item.checkedF,
                              e.target.value
                            )
                          }
                          value="checkedF"
                          color="primary"
                        />
                      }
                      label="Archivos"
                    />
                  </h4>
                  <h4 className={classes.itemText} style={{ width: "33%" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={item.checkedG ? true : false}
                          //  onChange={this.handleChange("checkedB")}
                          onClick={e =>
                            this.handleChange(
                              item,
                              !item.checkedG,
                              e.target.value
                            )
                          }
                          value="checkedG"
                          color="primary"
                        />
                      }
                      label="Reportes"
                    />
                  </h4>
                  <h4 className={classes.itemText} style={{ width: "33%" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={item.checkedH ? true : false}
                          // onChange={this.handleChange("checkedB")}
                          onClick={e =>
                            this.handleChange(
                              item,
                              !item.checkedH,
                              e.target.value
                            )
                          }
                          value="checkedH"
                          color="primary"
                        />
                      }
                      label="Clientes"
                    />
                  </h4>
                  <h4 className={classes.itemText} style={{ width: "33%" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={item.checkedI ? true : false}
                          //onChange={this.handleChange("checkedB")}
                          onClick={e =>
                            this.handleChange(
                              item,
                              !item.checkedI,
                              e.target.value
                            )
                          }
                          value="checkedI"
                          color="primary"
                        />
                      }
                      label="Usuarios"
                    />
                  </h4>
                </ListItem>
              );
            })}
          </List>
        ) : null}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end"
          }}
        >
          {/*  <Button
            variant="contained"
            color="primary"
            onClick={this.handleClickOpenNu}
            className={classes.button}
            endIcon={<AddIcon />}
          >
            Nuevo Rol
          </Button>*/}
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end"
          }}
        />

        <Dialog
          /*fullScreen */

          open={this.state.openNu}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <div>
            <DialogTitle id="form-dialog-title">Nuevo Rol</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Escriba un nombre para el rol de usuario
              </DialogContentText>
              {/*** Nombre de ROL ***/}
              <TextField
                autoFocus
                margin="dense"
                id="name"
                value={this.state.nombre}
                onChange={e => this.setState({ nombre: e.target.value })}
                label="Nombre"
                variant="outlined"
                type="name"
                fullWidth
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.setState({ openNu: false })}
                color="primary"
              >
                Cancelar
              </Button>
              <Button onClick={this.fillDb} color="primary">
                Crear
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(Roles);
